export default __webpack_public_path__ + "static/media/view-of-invoices-image.310d6461.png";